import { render, staticRenderFns } from "./vehicleInspectionReports.vue?vue&type=template&id=459a856c"
import script from "./vehicleInspectionReports.vue?vue&type=script&lang=js"
export * from "./vehicleInspectionReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports